import { observer } from "mobx-react-lite";
import './ConfigurableCard.scss'
import { Badge } from "./Badge";
import BadgeIcon from "./BadgeIcon";
import PetTooltip from "./PetTooltip";
import { Button } from "./Button";
import { store } from "../stores/Store";
import Icon from "./Icon";
import { useElementSize } from "../effects/useElementSize";
import { useWindowSize } from "../effects/useWindowSize";
import { useRef } from "react";
import { BREAKPOINT_MD, BREAKPOINT_SM } from "../stores/constants";
import { formatCurrency } from "../utils/Currency";
import { prepareDataAttributesObject } from "../utils/HtmlUtils";
import { ucfirst } from "../utils/Strings";
import CartButton from "./CartButton";
import ProductModel from "../stores/ProductModel";
import ProductConfigurationOption from "../models/ProductConfigurationOption";
import { CounterInput } from "./CounterInput.jsx";
import Select2 from "./Select2.jsx";
import { _t } from '../utils/Lang';


const ConfigurableCard = observer(({
    horizontalBreakpoint = BREAKPOINT_MD,
    data,
    onClick,
    onMoreClick,
    onMoreLinkClick,
    onAddToCartClick,
    inCart = false,
    children,
    name, price, image,
    discountedPrice,
    priceWrap = false,
    description,
    checked = false, showChecked = true,
    badgeText = null,
    attributesHeader = '',
    attributes = [],
    attributes2Header = '',
    attributes2 = [],
    className = '',
    hideSwatch = false,
    style = {},
}) => {

    const moreRef = useRef();
    // const [ref, size] = useElementSize();
    const size = useWindowSize();
    // MYB-144: the card shows the discounted price with the regular price
    // struck through underneath when a discount applies.
    const hasDiscount = discountedPrice !== undefined && discountedPrice !== null && discountedPrice !== price;
    var classes = ['ConfigurableCard', className];
    if (checked) {
        classes.push('ConfigurableCard--checked');
    }
    if (priceWrap) {
        classes.push('ConfigurableCard--price-wrap');
    }
    if (size.width < horizontalBreakpoint) {
        classes.push('ConfigurableCard--small');
    }
    const _onMoreClick = (e) => {
        e.persist();
        console.log({ ref: moreRef.current, target: e.target, e });
        if (e.target === moreRef.current && onMoreClick) {
            onMoreClick();
            console.log('more click');
            e.preventDefault();
        }
    }

    return (
        <div
            {...prepareDataAttributesObject(data)}
            onClick={(e) => {
                if (typeof onClick === 'function' && e.target.closest('.ConfigurableCard__button') === null && e.target.closest('.badges') === null && e.target.closest('.Select2') === null) {
                    onClick();
                }
            }}
            style={style}
            className={classes.join(' ')}>

            {
                (checked && showChecked) ? (
                    <svg
                        className="ConfigurableCard__icon"
                        width={18}
                        height={18}
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M-0.000488281 0H17.1424V14.5714C17.1424 16.465 15.6073 18 13.7138 18H-0.000488281V0Z"
                            fill="black"
                        />
                        <path
                            d="M4.99951 8.57139L7.99951 11.1428L12.8569 6"
                            stroke="white"
                            strokeWidth="0.857143"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>

                ) : null
            }

            <div className="ConfigurableCard__body">
                <div className="ConfigurableCard__photo-wrapper">
                    <div className="ConfigurableCard__photo">
                        <img src={image} alt={name} />


                        {badgeText && <div className="ConfigurableCard__bestseller d-flex a-center">
                            <Icon name={String(badgeText).toLowerCase()} className='' />
                            {ucfirst(badgeText)}
                        </div>}

                    </div>

                    <div className="ConfigurableCard__description">{description}</div>


                </div>
                <div className="ConfigurableCard__text">
                    <div className={`d-flex ${priceWrap ? 'flex-column' : ''} a-start w-100 mt-2 mb-2`}>
                        <div className="ConfigurableCard__title flex-grow-1">{name}</div>
                        <div className="d-flex f-col a-end">
                            <Badge style={{
                                whiteSpace: 'nowrap'
                            }}>+{formatCurrency(hasDiscount ? discountedPrice : price, { decimal: 0 })}</Badge>
                            {hasDiscount ? (
                                <div className="ConfigurableCard__price-old">+{formatCurrency(price, { decimal: 0 })}</div>
                            ) : null}
                        </div>
                    </div>

                    {/* <div className="ConfigurableCard__description">{description}</div> */}

                    {attributes2Header ? <div className="ConfigurableCard__header">{attributes2Header}</div> : null}

                    {
                        attributes2.length > 0 ? <ul>
                            {
                                attributes2.map((el, index) => {
                                    // debugger;
                                    return <li key={index}>

                                        {<Icon name={el.icon} />}
                                        {el.text}
                                    </li>
                                })
                            }
                        </ul> : null
                    }

                    {children}

                    <div className="ConfigurableCard__header">{attributesHeader}</div>
                    {
                        attributes.length > 0 ? <ul>
                            {
                                attributes.map((item, index) => {
                                    return <li key={index}>
                                        <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5.041 8.66709L9.30517 4.40292L8.83333 3.93109L5.041 7.72342L3.141 5.82342L2.66917 6.29525L5.041 8.66709ZM6.00217 12.0619C5.1725 12.0619 4.39244 11.9045 3.662 11.5896C2.93167 11.2747 2.29633 10.8474 1.756 10.3076C1.21567 9.76781 0.787944 9.13303 0.472833 8.40325C0.157611 7.67359 0 6.89387 0 6.06409C0 5.23442 0.157444 4.45436 0.472333 3.72392C0.787222 2.99359 1.21456 2.35825 1.75433 1.81792C2.29411 1.27759 2.92889 0.849865 3.65867 0.534753C4.38833 0.219531 5.16806 0.0619202 5.99783 0.0619202C6.8275 0.0619202 7.60756 0.219365 8.338 0.534254C9.06833 0.849143 9.70367 1.27648 10.244 1.81625C10.7843 2.35603 11.2121 2.99081 11.5272 3.72059C11.8424 4.45025 12 5.22998 12 6.05975C12 6.88942 11.8426 7.66948 11.5277 8.39992C11.2128 9.13025 10.7854 9.76559 10.2457 10.3059C9.70589 10.8463 9.07111 11.274 8.34133 11.5891C7.61167 11.9043 6.83194 12.0619 6.00217 12.0619ZM6 11.3953C7.48889 11.3953 8.75 10.8786 9.78333 9.84525C10.8167 8.81192 11.3333 7.55081 11.3333 6.06192C11.3333 4.57303 10.8167 3.31192 9.78333 2.27859C8.75 1.24525 7.48889 0.728587 6 0.728587C4.51111 0.728587 3.25 1.24525 2.21667 2.27859C1.18333 3.31192 0.666667 4.57303 0.666667 6.06192C0.666667 7.55081 1.18333 8.81192 2.21667 9.84525C3.25 10.8786 4.51111 11.3953 6 11.3953Z" fill="#AD864D" />
                                        </svg>

                                        {item}
                                    </li>
                                })
                            }
                        </ul> : null
                    }
                    <div className="mt-auto d-flex a-center j-between">


                        {typeof onMoreClick === 'function' ? (
                            <Button ref={moreRef} onClick={_onMoreClick} className="primary hollow btn-sm ConfigurableCard__button">{_t('learn_more')}</Button>
                        ) : null}

                        {typeof onMoreLinkClick === 'function' ? (
                            <a href="#" ref={moreRef} onClick={e => {
                                e.preventDefault();
                                onMoreLinkClick();
                            }}
                                className="primary hollow btn-sm ConfigurableCard__button">{_t('learn_more')}</a>
                        ) : null}
                        {typeof onAddToCartClick === 'function' ? (
                            <CartButton inCart={inCart} onClick={onAddToCartClick} />
                        ) : null}
                    </div>


                </div>
            </div>
        </div>
    )
});

ConfigurableCard.displayName = 'ConfigurableCard'
export default ConfigurableCard



const ConfigurableOption = observer(({ item, option, index, isLast, inCart }: { item: ProductModel, option: ProductConfigurationOption, index: number, isLast: boolean, inCart: boolean }) => {
    const canSelectQuantity = item.enable_quantity_selection;
    const o = option;
    return <div data-option-id={o.id} className="d-flex w-100 f-col mb-1">
        <div className="c-p-small" style={{
            display: index > 1 ? 'none' : 'block'
        }}>{o.name}</div>
        <div className="d-flex a-center">
            <Select2 className="Select2--radius Select2--configurator mb-0"
                dropdownContainer=".CartSummaryModal"
                value={item.getOptionValue(o.id)}
                disabled={inCart}
                onChange={(e, { value }) => { item.updateOption(o.id, value) }}
                options={o.options.map(o => {
                    if (canSelectQuantity) {
                        const numberlength = String(o.name).replace(/^[0-9]+/g, '').length;
                        let label = o.name;
                        if (numberlength > 5) {
                            // label = `${o.name} (${formatCurrency(o.price, { decimal: false })})`.replaceAll('cm', '').replaceAll(' ', '');
                            // label = `${o.name}`.replaceAll(' ', '');
                        } else if (numberlength > 3) {
                            label = `${o.name} (${formatCurrency(o.price, { decimal: false })})`.replaceAll('cm x', '').replaceAll(' ', '');
                        }
                        return ({ value: o.valueId, label: label });
                    }
                    return ({ value: o.valueId, label: o.name });
                })} />
            {(canSelectQuantity) ? (
                <CounterInput
                    value={item.quantity}
                    disabled={inCart}
                    onChange={value => {
                        if (value === 0 && item.owner) {
                            if (item.owner.sizes.length > 1) {
                                item.owner.removeSize(index);
                            }
                        } else {
                            item.updateQuantity(value)
                        }
                    }} />
            ) : null}
        </div>

    </div>

})

ConfigurableOption.displayName = 'ConfigurableOption'
export { ConfigurableOption }